import React from "react";
import { num, formatDate } from "@/lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";

export function DeliveryNotePrint({ doc, kind = "Pengiriman ke Armada", onClose }) {
  if (!doc) return null;
  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader className="sr-only">
          <DialogTitle>Surat Jalan {doc.trx_no}</DialogTitle>
          <DialogDescription>Pratinjau cetak surat jalan {kind}</DialogDescription>
        </DialogHeader>
        <div id="print-area" className="bg-white text-slate-900" data-testid="delivery-note-print">
          <div className="flex items-start justify-between border-b-2 border-slate-900 pb-4 mb-4">
            <div>
              <div className="font-display text-2xl font-bold">GudangKu</div>
              <div className="text-xs text-slate-500">Warehouse & Armada Sales</div>
            </div>
            <div className="text-right">
              <div className="font-display text-xl font-bold">SURAT JALAN</div>
              <div className="font-mono text-sm">{doc.trx_no}</div>
              <div className="text-xs text-slate-500 mt-0.5">{kind}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 text-sm mb-4">
            <div>
              <div className="text-xs font-mono uppercase text-slate-500">Sales / Armada</div>
              <div className="font-semibold">{doc.sales_name}</div>
              {(doc.vehicle_no || doc.vehicle_type) && (
                <div className="text-xs text-slate-500">{[doc.vehicle_type, doc.vehicle_no].filter(Boolean).join(" · ")}</div>
              )}
            </div>
            <div className="text-right space-y-0.5">
              <div>Tanggal: <span className="font-mono">{formatDate(doc.transaction_date || doc.date)}</span></div>
              {doc.notes && <div className="text-xs text-slate-500">Ket: {doc.notes}</div>}
            </div>
          </div>
          <table className="w-full text-sm mb-4">
            <thead>
              <tr className="border-b border-slate-300 text-left text-xs font-mono uppercase text-slate-500">
                <th className="py-1.5">SKU</th><th>Barang</th><th className="text-right pr-6">Qty</th><th>Kondisi</th>
              </tr>
            </thead>
            <tbody>
              {doc.items.map((it) => (
                <tr key={it.product_id} className="border-b border-slate-100">
                  <td className="py-1.5 font-mono text-xs">{it.sku}</td>
                  <td>{it.name}</td>
                  <td className="text-right font-mono pr-6">{num(it.qty)} {it.unit}</td>
                  <td>{it.condition || "Baik"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex justify-between mt-10 text-sm">
            <div className="text-center w-36"><div className="mb-14">Pengirim,</div><div className="border-t border-slate-400 pt-1">Gudang</div></div>
            <div className="text-center w-36"><div className="mb-14">Pengemudi,</div><div className="border-t border-slate-400 pt-1">{doc.sales_name}</div></div>
            <div className="text-center w-36"><div className="mb-14">Penerima,</div><div className="border-t border-slate-400 pt-1">&nbsp;</div></div>
          </div>
        </div>
        <div className="flex justify-end gap-2 print:hidden">
          <Button variant="outline" onClick={onClose}>Tutup</Button>
          <Button onClick={() => window.print()} className="bg-slate-900 hover:bg-slate-800" data-testid="btn-do-print"><Printer className="h-4 w-4 mr-1" />Cetak</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
